module.exports = __webpack_public_path__ + "img/zhichi (3).5323c8de.png";